<template>
  <div class="p-2 md:p-0">
    <form @submit.prevent="saveNoteForm()">
      <dl
        class="border rounded uk-description-list uk-description-list-divider mb-4"
        v-if="notes.length > 0"
      >
        <div class="p-2 border-b" v-for="note in notes">
          <div class="flex justify-between">
            <dd
              style="white-space: pre-wrap"
              class="font-medium"
              v-html="note.body"
            ></dd>

            <span style=" font-size: 9px">
              <vk-icon icon="user" ratio="0.5" />
              {{ note.agent_name }}
            </span>
          </div>
          <div style="clear: both"></div>

          <div class="flex   space-x-2" style="font-size:9px">
            <div class="border-r pr-2 flex">
              <div>Oluşturulma Tarihi :</div>
              <small style="font-size: 9px" class="font-semibold text-black">{{
                note.created_at | dateFormat
              }}</small>
            </div>
            <div class="flex">
              <div>Bildirim Tarihi :</div>
              <small style="font-size: 9px" class="font-semibold text-black">{{
                note.start | dateFormat
              }}</small>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </dl>
    </form>
  </div>
</template>

<script>
import HttpService from "../../services/http";

import Multiselect from "vue-multiselect";
import dateVue from "../Ui/Search/datetime.vue";
import moment from "moment";
import EventBus from "../Ui/EventBus";
export default {
  props: {
    field: String,
    table: String,
    id: String,
    selectedStatus: String,
  },
  components: {
    multiselect: Multiselect,
    datepicker: dateVue,
  },
  data() {
    return {
      notes: [],
      noteStatuses: [],
      activityForm: {
        quality: 5,
        body: "Telefon Araması Planlandı",
        notification: 1,
        agents: [
          {
            label: localStorage.getItem("userName"),
            value: localStorage.getItem("userId"),
          },
        ],
      },
      noteForm: {
        quality: 5,
        notification: null,

        agents: [
          {
            label: localStorage.getItem("userName"),
            value: localStorage.getItem("userId"),
          },
        ],
      },

      options: this.$root.cache.getOptions,
    };
  },

  filters: {
    dateFormat(val, type) {
      moment.locale("tr");
      return moment(val, type).format("DD MMMM YYYY, HH:mm");
    },
  },
  methods: {
    minuteConvert(e) {
      this.noteForm.start = moment()
        .add(e, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
      this.activityForm.start = moment()
        .add(e, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    setDatepickerActivity(e) {
      this.activityForm.start = e.value;
      this.activityForm.end = e.value;

      this.$forceUpdate();
    },
    setDatepickerNote(e) {
      this.noteForm.start = e.value;
      this.noteForm.end = e.value;

      this.$forceUpdate();
    },
    getVal(optionKey, value) {
      if (value) {
        return this.$root.cache.getOptions[optionKey].find(
          (e) => e.value == value
        ).label;
      } else {
        return "-";
      }
    },

    getData() {
      this.noteForm.lead_id = this.id;
      this.activityForm.lead_id = this.id;
      HttpService.notes({
        table: "notifications",
        field: "lead_id",
        id: this.id,
      }).then((response) => {
        this.notes = response.data.results;
        this.$emit("notSayisi", this.notes.length);
      });
    },
  },
  mounted() {
    EventBus.$on("getNote", () => {
      this.getData();
    });
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.note-statu-icons .active {
  background: #eee !important;
}

.uk-description-list {
  max-height: 500px;
  overflow-y: scroll;
}

.multiselect-agents .multiselect__tags {
  border-color: #ccc;
  margin-top: 10px;
}
</style>
